import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { getReferralById } from 'api/referral';

import Loading from 'components/loading/loading';
import NoAccess from 'pages/no_access';

import ViewComponent from './view_component/index';

const ReferralItem = () => {
  const [loading, setLoading] = useState(true);
  const [referral, setReferral] = useState(null);
  const { id } = useParams();

  const fetchReferral = useCallback(async () => {
    setLoading(true);

    const referral = await getReferralById(id);
    setReferral(referral);

    setLoading(false);
  }, [id]);

  useEffect(() => {
    fetchReferral();
  }, [fetchReferral]);

  const viewProps = {
    referral,
  };

  if (loading) return <Loading />;
  if (referral?.statusCode === 403) return <NoAccess />;

  return <ViewComponent {...viewProps} />;
};

export default ReferralItem;
